// extracted by mini-css-extract-plugin
export default {"img":"Slider_img__ZCNgM","name":"Slider_name__sZab9"};